import * as React from 'react'
import { IMembership } from '../../types'
import Hearing from '../icons/ui/Hearing'
import UserLogo from '../icons/ui/UserLogo'
import Walker from '../icons/ui/Walker'
import Wheelchair from '../icons/ui/Wheelchair'

export interface IMembershipUserInfo {
  membershipInfo: IMembership
}

const MembershipUserInfo = (props: IMembershipUserInfo) => (
  <div className='p3 flex flex-wrap items-start'>
    <div className='Title col-12 uppercase font-grey3 h6'>Membership request</div>

    <div className='col-12 flex mt2'>
      <UserLogo className='mr2' />
      <div>
        <div className='h5 font-dark-grey'>{props.membershipInfo.basicInfo.name}</div>
        <div className='h6 font-grey2'>{props.membershipInfo.basicInfo.dob}</div>
      </div>
    </div>

    <div className='flex flex-wrap col-12 mt3'>
      <div className='col-4 mr2'>
        <div className='Phone h6 font-grey2'>Phone Number</div>
        <div className='h5 font-dark-grey'>{props.membershipInfo.phoneNumber}</div>
      </div>

      <div className='col-6 ml2'>
        <div className='Email h6 font-grey2'>Email</div>
        <div className='h5 font-dark-grey'>{props.membershipInfo.email}</div>
      </div>
    </div>

    <div className='flex flex-wrap col-12 mt3'>
      <div className='col-4 mr2'>
        <div className='Organization h6 font-grey2'>Organization</div>
        <div className='h5 font-dark-grey'>{props.membershipInfo.organization}</div>
      </div>

      <div className='col-6 ml2'>
        <div className='Service h6 font-grey2'>Service</div>
        <div className='h5 font-dark-grey'>{props.membershipInfo.service}</div>
      </div>
    </div>

    <div className='flex flex-wrap items-start col-12 py2 my2 bt-grey6 bb-grey6'>
      <div className='col-6'>
        <div>
          <div className='Mobility h5 font-grey3'>Mobility</div>
        </div>
        {props.membershipInfo.mobility &&
          props.membershipInfo.mobility.map((item: any) => (
            <div className='col-12 flex items-start mt2' key={item.mobId}>
              <Wheelchair className='col-1 svg-grey3' />
              <div className='ml1 col-9'>
                <div className='h5 font-dark-grey'>{item.category}</div>
                <div className='h5 font-dark-grey mt1'>{item.mobName}</div>
                <div className='h6 font-grey2'>Active device</div>
              </div>
            </div>
          ))}

        <div className='col-12 flex items-start mt2'>
          <Walker className='col-1' />
          <div className='ml1 col-9'>
            <div className='Walker h5 font-dark-grey'>Walker</div>
            <div className='Folding h6 font-grey2'>Folding</div>
          </div>
        </div>
      </div>

      <div className='col-6 flex flex-wrap items-start'>
        <div className='Assistance col-12 h5 font-grey3 mb2'>Assistance</div>
        <Hearing className='col-1' />
        {props.membershipInfo.assistance && (
          <div className='ml1 col-9'>
            <div className='h5 font-dark-grey'>{props.membershipInfo.assistance.category}</div>

            <div className='h5 font-dark-grey'>{props.membershipInfo.assistance.name}</div>
            <div className='h6 font-grey2'>{props.membershipInfo.assistance.driverNotes}</div>
          </div>
        )}
      </div>
    </div>

    <div className='mt1'>
      <div className='Requested h6 font-grey2'>Requested</div>
      <div className='h5 font-dark-grey'>{props.membershipInfo.requestedTime}</div>
    </div>
  </div>
)

export default MembershipUserInfo



// WEBPACK FOOTER //
// ./src/components/membership-request/MembershipUserInfo.tsx